export function savedPageDepth(value: string | null): number {
  if (value === null) return 1;
  const depth = Number(value);
  return Number.isInteger(depth) && depth > 0 ? depth : 1;
}

export function shouldReplayPageDepth(
  currentDepth: number,
  savedDepth: number,
  hasNextPage: boolean,
): boolean {
  return hasNextPage && currentDepth < savedDepth;
}

export function restoredScrollOffset(value: string | null): number | null {
  if (value === null) return null;
  const offset = Number(value);
  return Number.isFinite(offset) && offset >= 0 ? offset : null;
}
